import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { computed, shallowRef, watch } from 'vue';

export const useTokenModeStore = defineStore('tokenMode', () => {
  const _isInTokenMode = shallowRef(false);
  const _isTokenModeCssEnabled = shallowRef(true);
  if (import.meta.client) {
    watch(
      () => {
        const isInTokenMode = _isInTokenMode.value;
        const isTokenModeCssEnabled = _isTokenModeCssEnabled.value;
        return isInTokenMode && isTokenModeCssEnabled;
      },
      (newVal, oldVal) => {
        if (oldVal !== newVal) {
          document.body.classList.toggle('isInTokenMode', newVal);
        }
      },
      {
        immediate: true,
      },
    );
  }
  return {
    _isInTokenMode,
    _isTokenModeCssEnabled,
    isInTokenMode: computed(() => _isInTokenMode.value),
    isTokenModeCssEnabled: computed(() => _isTokenModeCssEnabled.value),
    setIsInTokenMode (payload: boolean) {
      const { $awMergedConfig: { isTokenModeControlEnabled } } = useNuxtApp();
      if (isTokenModeControlEnabled) {
        _isInTokenMode.value = payload;
      }
    },
    setIsTokenModeCssEnabled (payload: boolean) {
      _isTokenModeCssEnabled.value = payload;
    },
  };
});
